var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"result-badge"},[(! _vm.showBadge)?_c('span',{staticClass:"no-results"}):(_vm.isPassed)?_c('span',{staticClass:"badge bg-success"},[_vm._v("Passed")]):(! _vm.isPassed)?_c('span',{staticClass:"badge bg-danger"},[_vm._v("Failed")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }